import { Button, Field, OtpInput, Stack, StatusBanner } from '../../../components/index.js'

/** The same box wherever six digits are asked for: the second step, the enrolment, and
 * a brand-new administrator's first sign-in (`TeamInvite`). */
export function CodeField({
  value,
  onChange,
  onSubmit,
  refused,
  loading,
  label,
}: {
  value: string
  onChange: (v: string) => void
  onSubmit: () => void
  refused: string | null
  loading: boolean
  label: string
}) {
  return (
    <Stack gap={4}>
      {/**
       * Six boxes, not a text field that happens to want six characters.
       *
       * The control now says how many digits it wants before anybody starts
       * typing, shows each one as it lands, and submits itself when the last
       * box fills — a code is copied from a phone and typed once, and making
       * somebody reach for a button after the sixth digit is a step for the
       * sake of having one.
       *
       * `onComplete` fires on paste as well, which is how a password manager
       * fills it.
       */}
      <Field label="Code">
        {({ id }) => (
          <OtpInput
            id={id}
            value={value}
            onChange={onChange}
            onComplete={onSubmit}
            disabled={loading}
          />
        )}
      </Field>
      {refused && <StatusBanner tone="error">{refused}</StatusBanner>}
      <Button
        size="lg"
        full
        loading={loading}
        disabled={value.trim().length < 6}
        onClick={onSubmit}
      >
        {label}
      </Button>
    </Stack>
  )
}
